import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/node_modules/.pnpm/next-intl@3.26.5_next@14.2.28_@babel+core@7.28.0_@opentelemetry+api@1.9.0_@playwright+test@1._fa4vikktssq6zfag5mtrvu3rfu/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/.pnpm/next@14.2.28_@babel+core@7.28.0_@opentelemetry+api@1.9.0_@playwright+test@1.54.2_babel-plugin_5r4bdk4zioirrgoy4qpyhz5n3y/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/.pnpm/next@14.2.28_@babel+core@7.28.0_@opentelemetry+api@1.9.0_@playwright+test@1.54.2_babel-plugin_5r4bdk4zioirrgoy4qpyhz5n3y/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/public/svg/header-logo.svg");
;
import(/* webpackMode: "eager" */ "/usr/src/app/public/svg/header-white-logo.svg");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/app/components/channel-logo/channelStyle.module.scss");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/app/components/channel-logo/client/ChannelLogoClientside.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SubpageMenuItem"] */ "/usr/src/app/src/app/components/header/menu/SubpageMenuItem.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LinkWithChannelLink"] */ "/usr/src/app/src/app/components/link/LinkWithChannel.tsx");
